<template>
  <table class="table table-hover align-middle">
    <slot />
  </table>
</template>
